import { c as _c } from "react/compiler-runtime";
import { useEventListener } from "usehooks-ts";
export const useEscapeKey = callback => {
  const $ = _c(2);
  let t0;
  if ($[0] !== callback) {
    t0 = event => {
      if (event.key === "Escape") {
        callback();
      }
    };
    $[0] = callback;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleEscape = t0;
  useEventListener("keydown", handleEscape);
};